import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "../../assets/css/modal.css";
import api from "../../seller-apis/api";
import { convertToLocalDateTime } from "../../utilities/ConvertDateFormat";

function PackageHistoryModal({ onHide, show, productId, url}) {
    const [selectedId, setSelectedId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [data, setData] = useState([]);

  useEffect(() => {
  if (show) {
    document.body.classList.add("blur-bg-weight-modal");
    fetchPkgHistory(1);
  }

  return () => {
    document.body.classList.remove("blur-bg-weight-modal");
  };
}, [show]);



    // l1-2553
    const fetchPkgHistory = async (pageNo) => {
        try {
            let reqBody = {
                product: productId,
                pageNo: pageNo || 1,
                size: 10,
                ...url && { "pkg.url": url }
            };
            const res = await api.product.getSellerWeightLockedHistory(reqBody);
            setCurrentPage(pageNo || 1);
            let newRecords = res?.records || [];
            if (pageNo && pageNo > 1) {
                newRecords = [...data, ...res?.records || []];
            }
            setData(newRecords);
            setTotalRecords(res?.totalRecords);
        } catch (err) {
            console.error("Error fetching package history:", err);
        }

    }

    const handleClose = () => {
        setData([]);
        setCurrentPage(1);
        setTotalRecords(0);
        onHide();
    }

    if (show) {

        return (
            <>
                <Modal className="custom-modal top-modal" centered show={show} backdrop="static">
                    <Modal.Header
                        onClick={() => handleClose()}
                        className="Confirmation-Modal-H"
                        closeButton
                        style={{ padding: '0px 0px 6px 0px' }}
                    >
                        <Modal.Title style={{ fontSize: '15px' }}>Package Details History</Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="prod-pkg-details" style={{ padding: '0px' }}>
                        <table className="table new-table-design">
                            <tr>
                                <th style={{ width: "30%" }}>Date</th>
                                <th style={{ width: "70%" }}>Status</th>
                            </tr>
                            <tbody>
                                {data.length > 0 &&
                                    data.map((item, index) => {
                                        let statement;
                                        let {date,time} = convertToLocalDateTime(item?.updatedAt)
                                        if (item.status === "V_PENDING") {
                                            statement = "Verfication pending from your side";
                                        } else if (item.status === "V_ACTIVE") {
                                            statement = "You accepted the package details.";
                                        } else if (item.status === "T_PENDING") {
                                            statement = "Verfication pending from Toolsvilla";
                                        } else if (item.status === "T_REJECT") {
                                            statement = "Toolsvilla rejected your package details";
                                        } else if (item.status === "V_REJECT") {
                                            statement =
                                                "You rejected offered package request from Toolsvilla";
                                        } else if (item.status === "T_ACTIVE") {
                                            statement = "Toolsvilla accepted the package details";
                                        }
                                        return (
                                            <>
                                                <tr key={index}>
                                                    <td>{date}
                                                        <br/>
                                                        <span className="fs-10 gry">{time}</span>
                                                    </td>
                                                    <td>{statement}</td>
                                                </tr>
                                            </>
                                        );
                                    })}
                            </tbody>
                        </table>
                        {totalRecords > currentPage * 10 && <>
                            <button onClick={() => fetchPkgHistory(currentPage + 1)} className="load-more-22 m-auto">Load More</button>
                        </>}
                    </Modal.Body>
                </Modal>
            </>
        );
    }
    else return <></>
}
export default PackageHistoryModal;
